import React, { useContext, useEffect, useState } from "react";
import "../../Dashboard/View_List/View_List.css";
// import Add from "./Add";
// import Edit from "./Edit";
import Delete_Points_Modal from "../../Common_Component/Common_Modal/Delete_Points_Modal/Delete_Points_Modal";
import { Button, Form, Modal, Table } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenToSquare, faTrash } from "@fortawesome/free-solid-svg-icons";
import {
  DepositStatus,
  findAll,
  findAllDeposit,
  Status,
} from "../../../utils/apis/wallet_management/wallet_hisory/wallet_history";

import {
  PaymentMethod,
  Per_Page_Dropdown,
  RequestStatus,
  users_type,
} from "../../../utils/common";
import Pagination_holder from "../../Common_Component/Pagination_holder/Pagination_holder";
import CustomPaginate from "../../Common_Component/CustomPaginate/CustomPaginate";
import { Context } from "../../../utils/context";
import { Country, State } from "../../../utils/apis/common/index";
import { formatDate } from "../../../utils/common";
import Select from "react-select";
import Add from "./Add";
import AddRequest from "./AddRequest";
import Heading_Holder from "../../Common_Component/Heading_Holder/Heading_Holder";
import ModalSave from "../../Common_Component/Common_Modal/Successfull_Modal/ModelSave";

const Tables = () => {
  const { UnauthorizedLogOut, Select2Data, IMG_URL, usertype, isAllow } =
    useContext(Context);

  const [modalShow, setModalShow] = useState(false);
  const [modalEditShow, setModalEditShow] = useState(false);
  const [modalDeleteShow, setModalDeleteShow] = useState(false);
  const [recordToDeleteId, setRecordToDeleteId] = useState(null);
  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setperPage] = useState(10);
  const [search, setSearch] = useState("");
  const [reset, setReset] = useState();
  const [changeStatus, setChangeStatus] = useState();
  const [option, setOption] = useState();
  const [searchDateTo, setSearchDateTo] = useState("");
  const [searchDateFrom, setSearchDatefrom] = useState("");
  const handleAccept = async (data) => {
    try {
      const response = await DepositStatus(data.id, {
        status: 1,
        request_status_id: RequestStatus.Accepted,
      });
      await setData(response?.data);
      setCurrentPage(response?.data?.data?.current_page);
      setperPage(response?.data?.data?.per_page);
      setSearch(response?.data?.data?.search_name);

      if (response?.data?.success) {
        await setShowModal({
          code: response.data.code,
          message: response.data.data,
        });
        setTimeout(() => {
          setShowModal(0);
        }, 1000);
      }

      setOption(await Per_Page_Dropdown(response?.data?.data?.total));
    } catch (error) {
      console.error(error.message);
      await UnauthorizedLogOut(error);
    }
  };

  const getDataAll = async () => {
    try {
      const response = await findAllDeposit(
        currentPage,
        perPage,
        search,
        searchDateFrom,
        searchDateTo,
      );

      await setData(response?.data);
      setCurrentPage(response?.data?.data?.current_page);
      setperPage(response?.data?.data?.per_page);
      setSearch(response?.data?.data?.search_name);

      setOption(await Per_Page_Dropdown(response?.data?.data?.total));
    } catch (error) {
      console.error(error.message);
      await UnauthorizedLogOut(error);
    }
  };

  useEffect(() => {
    getDataAll();
  }, [changeStatus, perPage, reset, modalShow, modalEditShow, currentPage]);

  // const StatusChange = async (id) => {
  //   const response = await Status(id);
  //   setChangeStatus(response);
  // };

  // const handleDeleteRecord = async () => {
  //   setModalDeleteShow(false);
  //   if (recordToDeleteId) {
  //     const response = await Delete(recordToDeleteId);
  //     setRecordToDeleteId(null);
  //     setChangeStatus(response);
  //   }
  // };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleDateChange = (date) => {
    setSearchDateTo(date); // Update the state with the selected date
  };

  const [showImageModal, setShowImageModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");

  return (
    <>
      <section className="View_List">
        <Heading_Holder headingText={"Wallet Deposit Request"} />
        <div className="search-bar-holder ">
          <Form>
            <div className="row align-items-end">
              {usertype == "Agent" ? (
                <div className="col-xxl-2 col-xl-3 col-lg-3 col-md-4 col-sm-5  col-holder">
                  <Button
                    type="button"
                    className="search-btn"
                    onClick={() => setModalEditShow(true)}>
                    withdrawal Request
                  </Button>
                </div>
              ) : (
                ""
              )}
              <div className="col-xxl-2 col-xl-3 col-lg-3 col-md-4 col-sm-5    ">
                <Form.Group className="form-field" controlId="formBasicEmail">
                  <Form.Control
                    type="text"
                    placeholder="Name/email"
                    onChange={(e) => setSearch(e.target?.value)}
                    value={search}
                  />
                </Form.Group>
              </div>
              <div className="col-xxl-2 col-xl-3 col-lg-3 col-md-4 col-sm-5    ">
                <Form.Group className="form-field" controlId="formBasicEmail">
                  <Form.Label className="formlbb">From</Form.Label>
                  <Form.Control
                    type="date"
                    placeholder="From"
                    max="9999-12-31"
                    min="0001-01-01"
                    value={searchDateFrom}
                    onChange={(e) => {
                      const value = e.target?.value;

                      // extra safety (optional)
                      const year = value.split("-")[0];
                      if (year.length !== 4) return;

                      setSearchDatefrom(value);
                    }}
                  />
                </Form.Group>
              </div>
              <div className="col-xxl-2 col-xl-3 col-lg-3 col-md-4 col-sm-5    ">
                <Form.Group className="form-field" controlId="formBasicEmail">
                  <Form.Label className="formlbb">To</Form.Label>
                  <Form.Control
                    type="date"
                    placeholder="to"
                    min={searchDateFrom} // already good
                    max="9999-12-31" // ✅ restrict year to 4 digits
                    value={searchDateTo}
                    onChange={(e) => {
                      const value = e.target?.value;

                      // basic format safety
                      if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) return;

                      const year = value.split("-")[0];
                      if (year.length !== 4) return;

                      handleDateChange(value);
                    }}
                  />
                </Form.Group>
              </div>

              <div className="col-xxl-2 col-xl-3 col-lg-3 col-md-4 col-sm-5  col-holder">
                <Button
                  type="button"
                  className="search-btn"
                  onClick={getDataAll}>
                  Search
                </Button>
              </div>

              <div className="col-xxl-2 col-xl-3 col-lg-3 col-md-4 col-sm-5   col-holder">
                <Button
                  type="button"
                  className="reset-btn"
                  onClick={() => {
                    setSearch("");
                    setSearchDateTo("");
                    setSearchDatefrom("");
                    setReset(!reset);
                  }}>
                  Reset
                </Button>
              </div>
              {/* <div className=" col-12 mt-3">
                <div className="d-flex  align-items-center">
                  <div className="show me-2">
                    <p style={{ color: "white" }} className="show m-0">
                      Show
                    </p>
                  </div>
                  <div className="number me-2">
                    <select
                      className="form-select form-select-sm"
                      aria-label=".form-select-sm example"
                      onChange={(e) => setperPage(e.target?.value)}
                    >
                      {option?.map((option) => (
                        <option key={option} value={option}>
                          {option}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="entries">
                    <p style={{ color: "white" }} className="show m-0">
                      entries
                    </p>
                  </div>

                  <div className="col-xxl-6 col-xl-6 col-lg-8 col-md-6 col-sm-2 col-12">
                    <div className="sowing me-2 ms-5">
                      <p
                        style={{ color: "white" }}
                        className="show m-0"
                      >{`Showing ${Math.min(
                        (currentPage - 1) * perPage + 1
                      )} to ${Math.min(
                        currentPage * perPage,
                        data?.data?.total
                      )} of ${data?.data?.total} entries`}</p>
                    </div>
                  </div>
                </div>
              </div> */}
            </div>
          </Form>
        </div>
        <div className="row">
          <div className="col-xl-12 col-lg-12 col-md-12">
            <div className="user-list-table">
              {/* <Banner_List_Table /> */}

              <div className="data-table-holder">
                <Table responsive bordered striped>
                  <thead>
                    <tr>
                      <th>Sr. No</th>
                      <th>Deposit Type</th>
                      <th>Name</th>
                      <th>Email</th>
                      <th>Points</th>
                      <th>UTR Number</th>
                      <th>Payment Proof</th>
                      <th>Payment ID</th>
                      <th>Date</th>
                      <th>Remark</th>
                      <th>Action</th>
                    </tr>
                  </thead>

                  <tbody>
                    {data?.data?.data?.length > 0 ? (
                      data.data.data.map((d, index) => {
                        return (
                          <tr>
                            <td>{(currentPage - 1) * perPage + index + 1}</td>
                            {/* <td>{index + 1}</td> */}
                            <td>{d?.PaymentMethod?.name ?? "-"}</td>
                            <td>{d?.User?.name ?? "-"}</td>
                            <td>{d?.User?.email ?? "-"}</td>
                            <td>{d?.amount ?? "-"} points</td>
                            <td>{d?.utr_number || "-"}</td>

                            <td>
                              {d?.payment_proof ? (
                                <img
                                  src={`${IMG_URL}${d.payment_proof}`}
                                  alt="Payment Proof"
                                  width="120"
                                  height="100"
                                  style={{
                                    objectFit: "cover",
                                    cursor: "pointer",
                                    borderRadius: "5px",
                                  }}
                                  onClick={() => {
                                    setSelectedImage(
                                      `${IMG_URL}${d.payment_proof}`,
                                    );
                                    setShowImageModal(true);
                                  }}
                                />
                              ) : (
                                "-"
                              )}
                            </td>

                            <td>{d?.payment_id ?? "-"}</td>
                            <td>{d?.remark ?? "-"}</td>
                            <td>{d?.createdAt?.split("T")[0] ?? "-"}</td>
                            <td>
                              {d?.request_status_id ===
                                RequestStatus.Processing &&
                              d.payment_method_id == PaymentMethod.Manual &&
                              isAllow?.includes(55) ? (
                                <>
                                  <button
                                    onClick={() => handleAccept(d)}
                                    className="btn btn-success"
                                    style={{ marginRight: "5px" }}>
                                    Accept
                                  </button>
                                  <button
                                    onClick={() => setModalShow(d?.id)}
                                    className="btn btn-danger">
                                    Reject
                                  </button>
                                </>
                              ) : d?.request_status_id ==
                                  RequestStatus.Accepted &&
                                d.payment_method_id == PaymentMethod.Manual ? (
                                <button
                                  className="btn btn-success"
                                  style={{ marginRight: "5px" }}>
                                  Accepted
                                </button>
                              ) : d?.request_status_id ==
                                  RequestStatus.Rejected &&
                                d.payment_method_id == PaymentMethod.Manual ? (
                                <button className="btn btn-danger">
                                  Rejected
                                </button>
                              ) : (
                                ""
                              )}
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td
                          colSpan={usertype != "Agent" ? 9 : 8}
                          className="text-center">
                          No Data
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>

                <CustomPaginate
                  currentPage={data?.data?.current_page}
                  totalPages={data?.data?.total_pages}
                  handlePageChange={handlePageChange}
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      <Add show={modalShow} onHide={() => setModalShow(false)} />
      <AddRequest show={modalEditShow} onHide={() => setModalEditShow(false)} />
      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />

      <Modal
        show={showImageModal}
        onHide={() => setShowImageModal(false)}
        centered
        size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Payment Proof</Modal.Title>
        </Modal.Header>

        <Modal.Body className="text-center">
          {selectedImage && (
            <img
              src={selectedImage}
              alt="Payment Proof"
              style={{
                maxWidth: "100%",
                maxHeight: "75vh",
                objectFit: "contain",
              }}
            />
          )}
        </Modal.Body>
      </Modal>

      {/* <Delete_Points_Modal
        show={modalDeleteShow}
        handleDeleteRecord={handleDeleteRecord}
        onHide={() => setModalDeleteShow(false)}
      /> */}
    </>
  );
};
export default Tables;
